{
  "display_name": "Andre",
  "download_url": "https://dev.hearthfire.ai/api/emergency-doc/01KQS5WS35.pdf",
  "generated_at": "May 9, 2026 at 7:14 PM",
  "household_name": "Andre's household"
}
